import { gql } from "@apollo/client";

import { PAYMENT_TERMINAL_FRAGMENT } from "./fragments";

export const PAYMENT_TERMINAL_CREATE_MUTATION = gql`
  ${PAYMENT_TERMINAL_FRAGMENT}
  mutation PaymentTerminalCreate($input: PaymentTerminalCreateInput!) {
    paymentTerminalCreate(input: $input) {
      ...PaymentTerminal
    }
  }
`;

export const PAYMENT_TERMINAL_DELETE_MUTATION = gql`
  ${PAYMENT_TERMINAL_FRAGMENT}
  mutation PaymentTerminalDelete($id: Int!) {
    paymentTerminalDelete(id: $id) {
      ...PaymentTerminal
    }
  }
`;
